<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="backButtonEnable"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="'Location'" />
    </template>

    <div class="split-view-template css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <GcDataGrid
              :grouping="true"
              :export="true"
              :summary="true"
              :dataSourceConfig="getDataSourceConfig"
              :columns="getColumns"
              :gridToolbar="getToolbar"
              :padColumn="true"
              :id="'split-view-grid'"
              :rowClick="rowClickCallBack"
              v-if="dataLoaded"
              :heightPadding="20"
              :paging="false"
              ref="split-view-grid"
            />
          </div>
        </template>

        <template #rightContent>
          <gc-form-header-toolbar
            :toolbar-options="getFormConfig.headerToolbar"
            :data-model="formModel"
            :backRoute="pageRoute"
            :formLocation="getFormConfig.headerToolbar.toolbarFormLocation"
            v-if="renderForm && dataLoaded"
            :itemSaveCallBack="itemSaveCallBack"
            :baseView="baseView"
          ></gc-form-header-toolbar>

          <div
            class="view-card responsive-paddings split-view-form"
            v-if="dataLoaded"
          >
            <GcForm
              :formOptions="formOptions"
              :formItems="getFormItems"
              :isNormal="true"
              :data-model="formModel"
              v-if="renderForm && dataLoaded"
              :formMode="baseView.mode"
              :valueChangeCallBack="valueChangeCallBack"
              :checkValid="isValid"
              :validationGroup="'split-view-form'"
              :formLocation="'normal'"
              :formContentReady="formContentReady"
              :formHeight="getFormHeight"
              ref="split-view-form"
              :onFormKeypress="onFormKeypress"
            />
          </div>
        </template>
      </gc-split-view>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../../_services/storage";
import { ProductAttributeService } from "../../../_services/api/settings/products/product-attribute.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { BranchService } from "../../../_services/api/sales/branch.service";
import { BinLocationTypeService } from "../../../_services/api/settings/products/bin-location-type.service";
import SettingsService from "../../../_services/api/settings/graycorp/settings.service";

// create a comment
const getFormItemPayloadValue = (formItemModel) =>
  formItemModel
    ? formItemModel._value
    : formItemModel === null
    ? ""
    : undefined;

export default {
  mixins: [RouteMixin, FormMixin],
  data() {
    return {
      backButtonEnable: true,
      AttributeName: undefined,
      dataLoaded: false,
      formOptions: {
        gcLabelLocation: "left",
      },
      formModel: {
        // Code: undefined,
        // Location: undefined,
        // Branch: undefined,
        // Site: undefined,
        // Building: undefined,
        // Area: undefined,
        // Aisle: undefined,
        // Bay: undefined,
        // Space: undefined,
        // Shelf: undefined,
      },
      editFormData: {},
      renderForm: false,
      isValid: false,
      formHeight: "auto",
      pageRoute: undefined,
      AttributeTableDefinitionRecordId: undefined,
      AttributeColumnDefinition: undefined,
      defaultBranch: undefined,
      defaultLocationType: undefined,
      LocationCodeRequired: false,
    };
  },
  async created() {
    this.showLoading(true);
    this.$store.dispatch("ui/headerFormHeight", undefined);
    this.pageRoute = "/" + this.baseView.view;
    // let view = this.baseView.view.split("-");
    // this.AttributeName = capitalizeFirstLetter(view[2]);
    await this.getAttributeTableDefinition();
    await this.getAttributeColumnDefinition();
    await BranchService.getDefault().then((res) => {
      this.defaultBranch = res.data.value[0].Code;
    });

    await BinLocationTypeService.getDefaultType().then((res) => {
      this.defaultLocationType = res.data.value[0].RecordId;
    });

    await this.setLocationCodeRequired();

    if (this.baseView.mode === "create") {
      this.renderForm = true;
    } else {
      if (this.baseView.id) await this.getRecord();
    }

    this.dataLoaded = true;
    this.showLoading(false);
  },

  computed: {
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
    getDataSourceConfig() {
      return {
        endpoint: "StorageLocationList",
        filter: "",
        // select: [
        //   "Code",
        //   "Description",
        //   "Wastage",
        //   "SalesGLChartCode",
        //   "CostGLChartCode",
        //   "StockGLChartCode",
        //   "PurchaseGLChartCode",
        //   "Inactive",
        //   "SalesGLChartDescription",
        //   "CostGLChartDescription",
        //   "StockGLChartDescription",
        //   "PurchaseGLChartDescription",
        //   "IsDefault",
        // ],
        serverPaging: true,
        allowGrouping: false,
      };
    },
    getColumns() {
      return [
        {
          screenField: "ColumnValue",
          filterIndex: 1,
          gridDataField: "Name",
          filterLabel: "Location",
          filterDataField: "LocationSearchText",
          dataType: "string",
          type: "Text",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.Name}
                        </span> <br />
                      <span class="record-secondary gc-grid-code">
                        ${info.data.Code}
                      </span>
                    </div>`);
          },
          allowHiding: false,
        },
        {
          screenField: "Code",
          gridDataField: "Code",
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "BinLocationType",
          gridDataField: "Type",
          visible: true,
        },
        {
          screenField: "Branch",
          gridDataField: "Branch",
          filterDataField: "Branch",
          width: ColumnWidth.BranchCode.width,
          maxWidth: ColumnWidth.BranchCode.width,
          cellTemplate: undefined,
          filterIndex: 2,
          exportFields: false,
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Site",
          filterDataField: "SiteRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          filterLabel: "Site",
          dataSourceConfig: this.getAttributeFilterData("Site"),
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 3,
          type: "String",
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Building",
          filterDataField: "BuildingRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Building"),
          filterLabel: "Building",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 4,
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Area",
          filterDataField: "AreaRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Area"),
          filterLabel: "Area",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 5,
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Aisle",
          filterDataField: "AisleRecordId",
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Aisle"),
          filterLabel: "Aisle",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 6,
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Bay",
          filterDataField: "BayRecordId",
          visible: false,
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Bay"),
          filterLabel: "Bay",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 7,
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Space",
          filterDataField: "SpaceRecordId",
          visible: false,
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Space"),
          filterLabel: "Space",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 8,
        },
        {
          screenField: "ColumnValue",
          gridDataField: "Shelf",
          filterDataField: "ShelfRecordId",
          visible: false,
          width: ColumnWidth.ColumnValue.width,
          maxWidth: ColumnWidth.ColumnValue.width,
          dataSourceConfig: this.getAttributeFilterData("Shelf"),
          filterLabel: "Shelf",
          valueExpr: "RecordId",
          displayExpr: "ColumnValue",
          filterIndex: 9,
        },
      ];
    },
    getToolbar() {
      return {
        search: true,
        columnChooser: true,
        export: false,
        openFilter: true,
        expand: false,
        customButtons: [
          {
            icon: "plus",
            label: "Add New",
            route: `/location/create`,
            clickAction: {},
            buttonLocation: "left",
            visible: FeatureStorage.checkPermission(
              this.$route.meta.applicationFeatureCode,
              "create"
            ),
          },
        ],
      };
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              screenField: "Code",
              required: this.LocationCodeRequired,
              dataField: "Code",
              allowUpdate: true,
              editorOptions: {
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                tabIndex: 0, // this.baseView.mode === "create" ? 0 : -1,
              },
            },
            {
              dataField: "Name",
              required: true,
              label: {
                text: "Location",
              },
              editorOptions: {
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
            },
            {
              screenField: "BinLocationType",
              dataField: "LocationType",
              label: {
                text: "Type",
              },
              required: true,
              valueExpr: "RecordId",
              displayExpr: "Description",
              type: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create") {
                    e.component
                      .instance()
                      .option("value", this.editFormData.LocationType);
                  } else {
                    e.component
                      .instance()
                      .option("value", this.defaultLocationType);
                  }
                },
              },
            },
            {
              screenField: "Branch",
              dataField: "Branch",
              label: {
                text: "Branch",
              },
              required: true,
            },
            {
              screenField: "ColumnValue",
              dataField: "Site",
              required: this.getAttributeIsRequired("Site"),
              label: {
                text: "Site",
              },
              dataSourceConfig: this.getAttributeFilterData("Site"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Site);
                },
              },
            },
            {
              screenField: "ColumnValue",
              dataField: "Building",
              required: this.getAttributeIsRequired("Building"),
              label: {
                text: "Building",
              },
              dataSourceConfig: this.getAttributeFilterData("Building"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Building);
                },
              },
            },
            {
              screenField: "ColumnValue",
              dataField: "Area",
              required: this.getAttributeIsRequired("Area"),
              label: {
                text: "Area",
              },
              dataSourceConfig: this.getAttributeFilterData("Area"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Area);
                },
              },
            },
            {
              screenField: "ColumnValue",
              dataField: "Aisle",
              required: this.getAttributeIsRequired("Aisle"),
              label: {
                text: "Aisle",
              },
              dataSourceConfig: this.getAttributeFilterData("Aisle"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Aisle);
                },
              },
            },
            {
              screenField: "ColumnValue",
              dataField: "Bay",
              required: this.getAttributeIsRequired("Bay"),
              label: {
                text: "Bay",
              },
              dataSourceConfig: this.getAttributeFilterData("Bay"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Bay);
                },
              },
            },
            {
              screenField: "ColumnValue",
              dataField: "Space",
              required: this.getAttributeIsRequired("Space"),
              label: {
                text: "Space",
              },
              dataSourceConfig: this.getAttributeFilterData("Space"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Space);
                },
              },
            },
            {
              screenField: "ColumnValue",
              dataField: "Shelf",
              required: this.getAttributeIsRequired("Shelf"),
              label: {
                text: "Shelf",
              },
              dataSourceConfig: this.getAttributeFilterData("Shelf"),
              valueExpr: "RecordId",
              displayExpr: "ColumnValue",
              type: "String",
              editorOptions: {
                onInitialized: (e) => {
                  if (this.baseView.mode !== "create")
                    e.component
                      .instance()
                      .option("value", this.editFormData.Shelf);
                },
              },
            },
          ],
        },
      ];
    },
    getFormHeight() {
      return "auto";
    },
    getFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission(
            this.$route.meta.applicationFeatureCode,
            "create"
          ),
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormLocation: "after",
        },
      };

      return form;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  methods: {
    getAttributeFilterData(AttributeName) {
      return {
        endpoint: "api/AttributeColumnValueLookup",
        sort: {
          selector: "ColumnValue",
          asc: true,
        },
        filter: [
          [
            "AttributeColumnDefinitionRecordId",
            "=",
            this.getAttributeColumnDefinitionRecordId(AttributeName),
          ],
        ],
        select: [
          "AttributeColumnDefinitionRecordId",
          "RecordId",
          "ColumnValue",
        ],
        keyType: {
          AttributeColumnDefinitionRecordId: "Guid",
          RecordId: "Guid",
        },
      };
    },
    getAttributeColumnDefinitionRecordId(AttributeName) {
      const record = this.AttributeColumnDefinition.find(
        (a) => a.AttributeName === AttributeName
      );

      if (record) {
        return record.RecordId; // return null if not valid GUID
      }

      return null; // if no record is found
    },
    async setLocationCodeRequired() {
      const result = await SettingsService.getBySettingNameFromDb(
        "LocationCodeRequired"
      );

      if (result && result.data.value.length > 0) {
        const record = result.data.value.find(
          (x) =>
            x.ApplicationFeatureCode == "StorageLocation" &&
            x.ScopeCode == "Global" &&
            x.SettingValue == "Y"
        );

        if (record) {
          this.LocationCodeRequired = true;
        } else {
          this.LocationCodeRequired = false;
        }
      } else {
        this.LocationCodeRequired = false;
      }
    },
    getAttributeIsRequired(AttributeName) {
      const record = this.AttributeColumnDefinition.find(
        (a) => a.AttributeName === AttributeName
      );

      if (record) {
        return record.IsRequired; // return null if not valid GUID
      }

      return false; // if no record is found
    },
    onFormKeypress(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
      }
    },
    /**
     * Fetches a record based on the current baseView id and sets the form model.
     */
    async getRecord() {
      await ProductAttributeService.getLocationByCode(this.baseView.id).then(
        (res) => {
          let data = res.data.value;
          this.formModel = {
            Code: data[0].Code,
            Name: data[0].Name,
            Branch: data[0].Branch,
            CreatedBy: data[0].CreatedBy,
            DateCreated: data[0].DateCreated,
            ChangedBy: data[0].ChangedBy,
            DateChanged: data[0].DateChanged,
          };
          this.editFormData = data.map((location) => {
            return {
              Code: location.Code,
              Name: location.Name,
              LocationType: location.TypeRecordId,
              Branch: location.Branch,
              Site: location.SiteRecordId,
              Building: location.BuildingRecordId,
              Area: location.AreaRecordId,
              Aisle: location.AisleRecordId,
              Bay: location.BayRecordId,
              Space: location.SpaceRecordId,
              Shelf: location.ShelfRecordId,
            };
          })[0];

          this.renderForm = true;
        }
      );
    },
    /**
     * Retrieves the attribute table definition for a given table name.
     * @param {string} tableName - The name of the table for which the attribute table definition is to be retrieved.
     * @returns {Object} The attribute table definition object containing metadata and schema information for the specified table.
     */
    async getAttributeTableDefinition() {
      await ProductAttributeService.getAttributeTableDefinition().then(
        (res) => {
          if (res.data.value.length > 0) {
            this.AttributeTableDefinitionRecordId = res.data.value[0].RecordId;
          }
        }
      );
    },
    /**
     * Retrieves the column definition for a given attribute.
     * @param {string} attributeName - The name of the attribute for which the column definition is to be retrieved.
     * @returns {Object|null} - The column definition object if found, otherwise null.
     */
    async getAttributeColumnDefinition() {
      await ProductAttributeService.getAttributeColumnDefinition(
        `AttributeTableDefinitionRecordId eq ${this.AttributeTableDefinitionRecordId} and DataSourceType eq 'Value Lookup'`
      ).then((res) => {
        if (res.data.value.length > 0) {
          this.AttributeColumnDefinition = res.data.value;
        }
      });
    },
    /**
     * Handles the change of local routes within the application.
     *
     * This function is triggered when there is a change in the local route.
     * It performs necessary actions to update the application state or UI
     * based on the new route.
     */
    async handleLocalRouteChange() {
      this.renderForm = false;
      if (this.baseView.mode === "create") {
        this.formModel = {
          Branch: this.defaultBranch,
          Type: this.defaultLocationType,
        };

        this.renderForm = true;
      } else {
        if (this.baseView.id) await this.getRecord();
        this.renderForm = true;
      }
    },
    /**
     * Handles the functionality for the back button.
     * This function is typically used to navigate to the previous page or state.
     */
    backButtonFunction() {
      this.$router.push({
        path: "/settings/products",
      });
    },
    /**
     * Callback function to handle row click events in a table.
     * @returns {void}
     */
    rowClickCallBack(e) {
      if (!e.data) return;
      this.onRowClicked(e, {
        view: this,
        page: this.baseView.view,
        mode: "review",
        idProperty: "RecordId",
        idMode: "Guid",
      });
    },
    /**
     * Callback function to handle value changes.
     *
     * @callback valueChangeCallBack
     * @param {string} isValid - validations status of the form elements.
     * @param {string} brokenRules - brokenRules, after validation is done.
     */
    async valueChangeCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.showLoading(true);
        let payload = {
          RecordId: "00000000-0000-0000-0000-000000000000",
          Code: this.formModel.Code,
          Name: this.formModel.Name,
          Type: this.formModel.LocationType,
          Branch: this.formModel.Branch,
          Aisle: getFormItemPayloadValue(this.formModel.Aisle),
          Area: getFormItemPayloadValue(this.formModel.Area),
          Bay: getFormItemPayloadValue(this.formModel.Bay),
          Building: getFormItemPayloadValue(this.formModel.Building),
          Shelf: getFormItemPayloadValue(this.formModel.Shelf),
          Site: getFormItemPayloadValue(this.formModel.Site),
          Space: getFormItemPayloadValue(this.formModel.Space),
        };

        if (this.baseView.mode !== "create")
          payload.RecordId = this.baseView.id;

        await ProductAttributeService.saveLocation(
          this.baseView.mode,
          payload,
          this.baseView.id
        )
          .then((res) => {
            this.showLoading(false);
            this.setIgnoreRouteChangeConfirmation();
            let recordID =
              this.baseView.mode === "create"
                ? res.data.RecordId
                : this.baseView.id;
            this.$router.push({
              path: this.pageRoute + "/review/" + recordID,
            });
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.displayServerError(err, "Save Failed");
          });
      }

      this.isValid = false;
    },
    /**
     * This function is called when the form content is ready.
     * It performs necessary actions to initialize or handle the form content.
     */
    formContentReady(e) {
      if (this.baseView.mode === "create" || this.baseView.mode === "edit")
        this.$nextTick(() => {
          if (e) e.component.getEditor("Code").focus();
        });

      // e.component.instance().option("formData", { ...this.editFormData });
    },
    /**
     * function to handle the save operation for an item.
     * This function is triggered when an item needs to be saved.
     */
    itemSaveCallBack() {
      this.isValid = true;
    },
  },
};
</script>
